export default "__VITE_ASSET__DmhrElo5__"